"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../const");

var _helpers = require("../../helpers");

var _themeOptions = require("../../helpers/theme-options");

var _useMedia = require("../../hooks/use-media");

var _useStyles = require("../../hooks/useStyles");

var _linkUi = _interopRequireDefault(require("../link/link-ui"));

var _const2 = require("../link/const");

var _styled = require("../../styled");

var _carouselUi = _interopRequireDefault(require("../carousel/carousel-ui"));

var _headerTitles = require("../header-titles");

var _lazyLoadImage = require("../lazy-load-image");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _iconGrid = require("./icon-grid.styled");

var _style = _interopRequireDefault(require("./style"));

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconGrid = function IconGrid(_ref) {
  var _ref$theme = _ref.theme,
      currentTheme = _ref$theme === void 0 ? _themeOptions.ThemeNoCardVariants.WHITE : _ref$theme,
      id = _ref.id,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 2 : _ref$columns,
      headline1 = _ref.headline1,
      headline2 = _ref.headline2,
      description = _ref.description,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      _ref$columnContents = _ref.columnContents,
      columnContents = _ref$columnContents === void 0 ? [] : _ref$columnContents,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? _const.TextAlignment.CENTER : _ref$textAlign,
      _ref$desktopIconPosit = _ref.desktopIconPosition,
      desktopIconPosition = _ref$desktopIconPosit === void 0 ? 'top' : _ref$desktopIconPosit,
      _ref$tabletIconPositi = _ref.tabletIconPosition,
      tabletIconPosition = _ref$tabletIconPositi === void 0 ? 'top' : _ref$tabletIconPositi,
      removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding,
      _ref$mobileLayout = _ref.mobileLayout,
      mobileLayout = _ref$mobileLayout === void 0 ? _types.KeyValueLayoutType.grid : _ref$mobileLayout;
  var isOneLineHeading = !(headline2 && (headline1 || description));
  var _themeNoCardStrategy$ = _themeOptions.themeNoCardStrategy[currentTheme],
      type = _themeNoCardStrategy$.type,
      isCardsTransparent = _themeNoCardStrategy$.isCardsTransparent,
      headline1Color = _themeNoCardStrategy$.headline1Color,
      headline2Color = _themeNoCardStrategy$.headline2Color;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isDarkThemeWithTransparentCards = isDarkTheme && isCardsTransparent;
  var arrowColor = isDarkTheme ? 'light' : 'dark';
  var mainButtonColor = (0, _helpers.getButtonColorByTheme)(isDarkTheme);
  var mainColor = isDarkThemeWithTransparentCards ? 'white' : 'gray800';
  var gridButtonColor = (0, _helpers.getButtonColorByTheme)(isDarkThemeWithTransparentCards);
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var isTablet = (0, _useMedia.useMedia)(_const.Breakpoints.TABLET);
  var paddingSize = isMobile ? _const.MOBILE_PADDING_SIZE : _const.DEFAULT_PADDING_SIZE;
  var styles = (0, _useStyles.useStyles)('a', _style.default);
  var theme = {
    $theme: currentTheme,
    $oneLineHeading: isOneLineHeading,
    $columns: columns,
    $textAlign: textAlign,
    $styles: styles,
    $descriptionLinkColor: isDarkTheme ? 'white' : 'wine'
  };
  var isIconLeftDesktop = desktopIconPosition === 'left';
  var isIconLeftTablet = tabletIconPosition === 'left';
  var inScrolledOnMobile = mobileLayout === _types.KeyValueLayoutType.scroll;
  var isCarouselOnMobile = mobileLayout === _types.KeyValueLayoutType.carousel;
  var responsive = [{
    adaptiveHeight: true,
    breakpoint: Number(_uiKit.GridBreakpointsMax.xl),
    settings: {
      slidesToShow: inScrolledOnMobile ? 3 : 2,
      variableWidth: inScrolledOnMobile
    }
  }, {
    breakpoint: Number(_uiKit.GridBreakpointsMax.lg),
    settings: {
      slidesToShow: inScrolledOnMobile ? 2 : 1,
      variableWidth: inScrolledOnMobile
    }
  }, {
    breakpoint: Number(_uiKit.GridBreakpointsMax.md),
    settings: {
      slidesToShow: 1,
      variableWidth: inScrolledOnMobile
    }
  }];
  var boxStyles = {
    mt: {
      xs: 10,
      md: isIconLeftTablet ? 0 : 10,
      xl: isIconLeftDesktop ? 0 : 10
    },
    pl: {
      xs: 0,
      md: isIconLeftTablet ? 30 : 0,
      xl: isIconLeftDesktop ? 30 : 0
    }
  };
  var containerStyles = {
    pt: removeTopPadding ? 0 : paddingSize,
    pb: removeBottomPadding ? 0 : paddingSize
  };
  var buttonBoxStyles = {
    mt: {
      xs: 30,
      lg: 45
    }
  };
  var GridItems = columnContents.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_iconGrid.GridItem, {
      key: index,
      display: {
        xs: 'block',
        md: isIconLeftTablet ? 'flex' : 'block',
        xl: isIconLeftDesktop ? 'flex' : 'block'
      },
      p: [isCardsTransparent ? 15 : 30]
    }, /*#__PURE__*/_react.default.createElement(_iconGrid.ImageWrapp, {
      isIconLeftDesktop: isIconLeftDesktop,
      isIconLeftTablet: isIconLeftTablet,
      alignCenter: textAlign === _const.TextAlignment.CENTER
    }, item.imageLink ? /*#__PURE__*/_react.default.createElement(_linkUi.default, {
      link: item.imageLink,
      target: (0, _const2.linkTarget)(item.imageLink)
    }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: item.image,
      placeholderSrc: item.image,
      alt: item.altText,
      skipLazy: (isMobile || isTablet) && (isCarouselOnMobile || inScrolledOnMobile)
    })) : /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: item.image,
      placeholderSrc: item.image,
      alt: item.altText,
      skipLazy: (isMobile || isTablet) && (isCarouselOnMobile || inScrolledOnMobile)
    })), /*#__PURE__*/_react.default.createElement(_iconGrid.ItemWrap, {
      mt: boxStyles.mt,
      pl: boxStyles.pl,
      fullWidth: true,
      isIconLeftDesktop: isIconLeftDesktop,
      isIconLeftTablet: isIconLeftTablet
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
      fullWidth: true
    }, !!item.headline && /*#__PURE__*/_react.default.createElement(_iconGrid.Line1, {
      color: mainColor
    }, item.headline), !!item.columnText && /*#__PURE__*/_react.default.createElement(_iconGrid.Line2, {
      color: mainColor,
      dangerouslySetInnerHTML: {
        __html: item.columnText
      }
    })), /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
      fullWidth: true
    }, !!(item.ctaLink && item.ctaText) && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
      color: gridButtonColor,
      buttons: [{
        link: item.ctaLink,
        text: item.ctaText,
        type: item.ctaType
      }],
      measure: "sm",
      isButtonFullWidth: true,
      alignCenter: textAlign === _const.TextAlignment.CENTER
    }))));
  });
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_iconGrid.Container, {
    pt: containerStyles.pt,
    pb: containerStyles.pb,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_ICON_GRID,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_iconGrid.HeaderWrapStyled, {
    p: [0, 15]
  }, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    fullWidth: true,
    noGutters: true,
    descriptionAlign: textAlign
  })), /*#__PURE__*/_react.default.createElement(_iconGrid.Grid, {
    mobileLayout: mobileLayout,
    hideMd: inScrolledOnMobile || isCarouselOnMobile
  }, GridItems), (inScrolledOnMobile || isCarouselOnMobile) && /*#__PURE__*/_react.default.createElement(_styled.ShowMd, null, /*#__PURE__*/_react.default.createElement(_iconGrid.Grid, {
    mobileLayout: mobileLayout
  }, inScrolledOnMobile && /*#__PURE__*/_react.default.createElement(_iconGrid.ScrollWrapStyled, null, /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
    settings: {
      dots: false,
      arrows: false,
      infinite: false,
      lazyLoad: 'progressive',
      responsive: responsive
    },
    inverse: isDarkTheme,
    transparent: true
  }, GridItems)), isCarouselOnMobile && /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
    arrowStyle: "flat",
    arrowColor: arrowColor,
    settings: {
      dots: false,
      arrows: true,
      infinite: true,
      responsive: responsive,
      lazyLoad: 'progressive'
    },
    inverse: isDarkTheme,
    transparent: true
  }, GridItems))), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    color: mainButtonColor,
    mt: buttonBoxStyles.mt
  })));
};

var _default = IconGrid;
exports.default = _default;